/* @flow */

import { rem } from 'polished';

import { baseFontSize } from '@e180/ui/lib/token/typography';

export default {
  root: {
    width: 34,
    height: 31,
    marginLeft: rem(2, baseFontSize),
  },
};
